import { Route } from '@angular/router'
import { TaxonomyDetailComponent } from '../taxonomy-detail/taxonomy-detail.component'
import { createTaxonomyDefinition } from '../taxonomy-detail/taxonomy.definition'

import { PermissionGuard } from '../../abacus/guards/permission.guard'
import { AuthGuard } from '../../abacus/guards/auth.guard'

import { TargetUserListComponent } from './target-user-list/target-user-list.component'

export const targetUserRoutes: Route[] = [
  {
    path: 'target-users',
    component: TargetUserListComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permission: 'browseTaxonomies'
    }
  },
  {
    path: 'target-users/:id/edit',
    redirectTo: 'target-users/:id',
    pathMatch: 'full'
  },
  {
    path: 'target-users/:id',
    component: TaxonomyDetailComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      definition: createTaxonomyDefinition({
        className: 'TargetUser',
        nameSingular: 'Target User',
        namePlural: 'Target Users',
        path: 'target-users',
        slug: 'taxonomies/target-users',
        title: 'Target Users'
      }),
      permission: 'readTaxonomies'
    }
  }
]
